'use client'
import React from 'react'
import { hover, motion } from 'motion/react';
import { useRouter } from 'next/navigation';
import { twMerge } from 'tailwind-merge';

interface Props
{
    children?: string;
    link: string;
    className?: string;
    hoverColor?: string;
    isActive?: boolean;
}

const Navlink = ({children, link, hoverColor='var(--foreground)', className="", isActive=false}: Props) => {

    const router = useRouter()

    className = twMerge("navlink ", className);

    const clickLink = (e: React.MouseEvent) => {
        router.push(link);
    }

    return (
        <motion.button
            className={className}
            style={isActive ? { color: 'var(--uforeground2)' } : {}}
            whileHover={{scale: 1.05, color: hoverColor}}
            whileTap={{scale: 1, color: hoverColor}}
            onClick={clickLink}
            >
            {children}
        </motion.button>
  )
}

export default Navlink
